const defaultState = {
  cards: [],
  meta: {},
  loading: false,
  errors: null,
  bonuses: []
}

export default defaultState
